module.exports = __webpack_public_path__ + "static/media/Panther859_2c2.21b5556d.svg";